// extracted by mini-css-extract-plugin
export var overlay = "MediaGalleryModal-module--overlay--3-mFt";
export var modalPadding = "MediaGalleryModal-module--modalPadding--2xTnK";